'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _ = require('../');

var _CompanyIsSjf = require('./CompanyIsSjf.css');

var _CompanyIsSjf2 = _interopRequireDefault(_CompanyIsSjf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompanyIsSjf = (_dec = (0, _reactCssModules2.default)(_CompanyIsSjf2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CompanyIsSjf, _Component);

  function CompanyIsSjf(props) {
    (0, _classCallCheck3.default)(this, CompanyIsSjf);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CompanyIsSjf.__proto__ || (0, _getPrototypeOf2.default)(CompanyIsSjf)).call(this, props));

    _this.state = {
      dei_score: props.company.dei_score ? _convert2.default.float(props.company.dei_score) * 100 : null,
      rji_score: props.company.rji_score ? _convert2.default.float(props.company.rji_score) * 100 : null,
      hrc_score: props.company.hrc_score ? _convert2.default.float(props.company.hrc_score) * 100 : null
    };
    return _this;
  }

  (0, _createClass3.default)(CompanyIsSjf, [{
    key: 'render',
    value: function render() {
      var iconGef = require('../../../static/images/icn-gef-black.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'family-modal' },
        _react2.default.createElement(
          'div',
          { styleName: 'icon-row' },
          this.props.company.gef_score ? _react2.default.createElement(_.CompanyIsFlag, { icon: iconGef, title: 'Rated on gender equality by Equileap' }) : null
        ),
        this.props.company.gef_score ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Gender equality:'
            ),
            ' This company has been rated by Equileap on gender equality. The score contributes to our Gender Equality Funds and Social Justice Funds scores. To find out more about how this company is rated on gender equality, visit ',
            _react2.default.createElement(
              _.Link,
              {
                to: _config2.default.links.equileap,
                title: 'Equileap',
                xstrong: true
              },
              'Equileap'
            ),
            ' for more information.'
          ),
          _react2.default.createElement('br', null)
        ) : null
      );
    }
  }]);
  return CompanyIsSjf;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = CompanyIsSjf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsSjf.js
// module id = 1383
// module chunks = 0